import axios from 'utils/axios';

const API_URL = 'performanceEvaluation';

export const getBatchStudents = async (
  batchId: string,
  assessmentSessionId?: string,
  params?: { page?: number; limit?: number; search?: string; sortColumn?: string; sortOrder?: 'asc' | 'desc' }
) => {
  return await axios.get(API_URL + '/batchStudents', {
    params: { batchId, assessmentSessionId, ...params }
  });
};

export const saveMarks = async (payload: any) => {
  return await axios.post(`${API_URL}/`, payload);
};

export const getPerformanceEvaluation = async (batchId: string, studentId: string, assessmentSessionId: string) => {
  return await axios.get(`${API_URL}`, {
    params: { batchId, studentId, assessmentSessionId }
  });
};

export const getOverallResult = async (
  batchId: string,
  params?: { page?: number; limit?: number; sortColumn?: string; sortOrder?: 'asc' | 'desc'; assessmentSessionId?: string }
) => {
  return await axios.get(API_URL + '/overallResult', {
    params: { batchId, ...params }
  });
};

export const releaseResults = async (batchId: string, assessmentSessionId: string) => {
  return await axios.post(API_URL + '/releaseResults', { batchId, assessmentSessionId });
};

export const getAssessmentHistory = async (batchId: string, studentId: string) => {
  return await axios.get('batch/assessmentHistory', {
    params: { batchId, studentId }
  });
};
